import PropTypes from 'prop-types';
import { CSVLink } from 'react-csv';

function ExcelDownload({ data, filename, txtLink }) {
  return (
    <CSVLink data={data} filename={filename}>
      {txtLink || 'הורדה לאקסל'}
    </CSVLink>
  );
}

export default ExcelDownload;

ExcelDownload.propTypes = {
  data: PropTypes.array,
  filename: PropTypes.string,
  txtLink: PropTypes.string
};
